export const version = "3.64";
export const domain = "https://nqapp.nurulquran.com"
